import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareA = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler1') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler1', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'KQ head!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'KQ head!!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareA}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareA
  
